import React from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/nextjs';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { fetchMobilePlan } from '@thunks/mobilePlan';
import { wrapper } from '@store/store';

import MobileOrderForm from '@routes/MobileOrderForm';

import request from '@utils/request';
import { validateRedirectsByResolvedUrl } from '@utils/redirects';

import {
  mobileProviders as mobileProvidersEndpoint,
  mobileTermsLinks as mobileTermsLinksEndpoint,
} from '@common/endpoints';

const MobileOrderFormPage = ({ providersList, mobileTermsLinks }) => (
  <MobileOrderForm
    providersList={providersList}
    mobileTermsLinks={mobileTermsLinks}
  />
);

export const getServerSideProps = wrapper.getServerSideProps(
  store =>
    async ({ locale, resolvedUrl, params: { plan } }) => {
      let providersList = [];
      let mobileTermsLinks = {};

      try {
        const { data: providersData } = await request.get(
          mobileProvidersEndpoint(),
        );
        const { data: mobileTermsLinksData } = await request.get(
          mobileTermsLinksEndpoint(),
        );

        await store.dispatch(fetchMobilePlan(plan));

        providersList = providersData;
        mobileTermsLinks = mobileTermsLinksData;
      } catch (e) {
        if (e.response?.status !== 404) {
          Sentry.captureException(e);
        }

        const validatedRedirects = validateRedirectsByResolvedUrl(resolvedUrl);

        if (validatedRedirects) {
          return {
            redirect: validatedRedirects,
          };
        }

        return {
          notFound: true,
        };
      }

      return {
        props: {
          ...(await serverSideTranslations(locale)),
          providersList,
          mobileTermsLinks,
        },
      };
    },
);

MobileOrderFormPage.propTypes = {
  providersList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      logo: PropTypes.string,
    }),
  ).isRequired,
  mobileTermsLinks: PropTypes.shape({
    dataProtectionDeclaration: PropTypes.string,
    termsAndConditions: PropTypes.string,
  }).isRequired,
};

export default MobileOrderFormPage;
